import TimeAllocationsPage from '../pages/admin/time-allocations/time-allocations-page'
export default TimeAllocationsPage
